import { tv } from "tailwind-variants";
import { text } from "../Text/text.variant";

export const button = tv({
  base: "inline-flex items-center justify-center gap-2.5 rounded-[20px] px-4 py-1 select-none cursor-pointer",
  variants: {
    size: {
      small: "h-7 px-2 py-1",
      medium: "h-9 w-auto px-4 py-2",
    },
    variant: {
      default: "border-none",
      outlined: "border-2 border-[var(--color-purple-9)] bg-transparent",
    },
    mode: {
      light: "",
      dark: "",
    },
    color: {
      primary:
        "bg-[var(--color-purple-5)] text-white " +
        "hover:bg-[var(--color-purple-4)] hover:shadow-[var(--shadow-button-hover)]  " +
        "focus:outline-none focus:ring-2 focus:ring-[var(--color-purple-4)] " +
        "active:bg-[var(--color-purple-5)] active:shadow-[var(--shadow-button-inner)]",
      secondary:
        "bg-[var(--color-blue-7)] text-white" +
        "hover:bg-[var(--color-blue-6)]  hover:shadow-[var(--shadow-button-hover)]" +
        "active:bg-[var(--color-blue-7)] active:shadow-[var(--shadow-button-inner)]",
      nocolor:
        "bg-transparent text-[var(--color-neutral-8)] " +
        "hover:bg-[var(--color-purple-2)] hover:shadow-[var(--shadow-button-hover)] hover:text-white" +
        "focus:outline-none focus:ring-2 focus:ring-[var(--color-purple-2)] " +
        "active:bg-[var(--color-purple-2)] active:shadow-[var(--shadow-button-inner)]",
    },
    rounded: {
      true: "rounded-full",
      false: "rounded-[20px]",
    },
  },
  compoundVariants: [
    {
      size: "small",
      class: text({ size: "title-small" }),
    },
    {
      size: "medium",
      class: text({ size: "title-medium" }),
    },
    {
      color: "primary",
      mode: "dark",
      class:
        "bg-[var(--color-purple-2)] text-[var(--color-neutral-8)]" +
        "hover:bg-[var(--color-purple-1)] hover:shadow-[var(--shadow-button-hover)]" +
        "active:bg-[var(--color-purple-2)] active:shadow-[var(--shadow-button-inner)]",
    },
    {
      color: "secondary",
      mode: "dark",
      class:
        "bg-[var(--color-blue-2)] text-[var(--color-neutral-8)]" +
        "hover:bg-[var(--color-blue-3)] hover:shadow-[var(--shadow-button-hover)]" +
        "active:bg-[var(--color-blue-2)] active:shadow-[var(--shadow-button-inner)]",
    },
  ],
  defaultVariants: {
    size: "medium",
    variant: "default",
    mode: "light",
    color: "primary",
    rounded: false,
  },
});
